import Vue from 'vue'
import Router from 'vue-router'

import HomePage from './views/HomePage.vue'
import SinglePage from './views/SinglePage.vue'

const SinglePost = () => import('@/views/SinglePost')
const Page404 = () => import('@/views/Page404')

import ArchivePosts from './views/ArchivePosts.vue'

const WPVUE = window.WPVUE;
Vue.use(Router)
// since first title will be pushed as PHP server will do it, I set it like that
const defaultTitle = document.title;

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (to.hash) {
				return {
				selector: to.hash
				// , offset: { x: 0, y: 10 }
				}
			}else if(to.path === from.path){
				// is same url, maybe just change  query
			} else{
				return { x: 0, y: 0 }
			}
		}
	},
	routes: [
    {
		path: "/",
		name: "frontPage",
		component: HomePage,
		meta: { post_type: 'page', type: 'frontPage', title: defaultTitle, id: WPVUE.page_on_front },
	},

	{
		path: '/404', name: 'notFound', component: Page404,
		meta: { post_type: null, type: '404', title: 'Side ikke funnet' }
	},
	
	//POSTS
	{
		path: `/${WPVUE.blog_base.slug}`, name: 'archivePosts', component: ArchivePosts,
		meta: { post_type: 'post', type: 'archive', title: defaultTitle, id: WPVUE.page_for_posts }
	},
	{
		path: `/${WPVUE.blog_base.slug}/:name`, name: 'singlePost', component: SinglePost,
		meta: { post_type: 'post', type: 'single', title: defaultTitle }
	},
	//Venue
	{
		path: `/opplevelser`, name: 'archiveVenue', component: ArchivePosts,
		meta: { post_type: 'venu', type: 'archive', title: defaultTitle, id: WPVUE.options.venue_archive }
	},
	{
		path: `/opplevelser/:name`, name: 'singleVenue', component: SinglePost,
		meta: { post_type: 'venu', type: 'single', title: defaultTitle }
	},
	//Events
	{
		path: `/arrangementer`, name: 'archiveEvents', component: ArchivePosts,
		meta: { post_type: 'events', type: 'archive', title: defaultTitle, id: WPVUE.options.events_archive }
	},
	{
		path: `/arrangementer/:name`, name: 'singleEvent', component: SinglePost,
		meta: { post_type: 'events', type: 'single', title: defaultTitle }
	},
  	{
		path: '/:name',
		name: 'singlePage',
		component: SinglePage,
		meta: { post_type: 'page', type: 'single', title: defaultTitle },
		children: [{
			path: ':name',
			component: SinglePage,
			meta: { post_type: 'page', type: 'single', title: defaultTitle },
			children: [
			{
				path: ':name',
				meta: { post_type: 'page', type: 'single', title: defaultTitle },
				component: SinglePage,
				children: [
				{
					path: ':name',
					meta: { post_type: 'page', type: 'single', title: defaultTitle },
					component: SinglePage,
					children: [
						{
							path: ':name',
							meta: { post_type: 'page', type: 'single', title: defaultTitle },
							component: SinglePage
						}]
				}]
			}]
		}]
	}]
	
})
